<template>
    <div class="Notification">
        <v-layout align-center justify-space-between class="page-header">
            <v-btn flat dark @click="go_back">
                <v-icon class="mr-1">mdi-chevron-left</v-icon>
                {{ $t('back') }}
            </v-btn>
            <div class="page-title">
                {{ $t('notification') |capitalize }}
            </div>
            <div></div>
        </v-layout>
        <div class="page-body">
            <div class="elevation-1" style="padding: 20px">
                <v-layout wrap>
                    <div style="width: 300px" class="mr-3">
                        <v-text-field
                            :label="$t('search') | capitalize"
                            v-model="search"
                            @keypress.enter="refresh"
                        ></v-text-field>
                    </div>
                    <div style="width: 300px" class="mr-3">
                        <v-select
                            :label="$t('notifyType') | capitalize"
                            :items="typeList"
                            v-model="typeFilter"
                        ></v-select>
                    </div>
                    <div style="width: 150px" class="mr-3">
                        <v-select
                            :label="$t('status') | capitalize"
                            :items="statusList"
                            v-model="status"
                        ></v-select>
                    </div>
                    <v-spacer></v-spacer>
                    <TimeRangePicker ref="TimeRangePicker" v-model="timeRange"></TimeRangePicker>
                </v-layout>
                <v-data-table
                    :items="items"
                    :headers="headers"
                    :pagination.sync="pagination"
                    :total-items="totalItems"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td class="single-line" v-html="props.item.formatted_msg"></td>
                            <td class="single-line">{{ props.item.created_time | moment("DD/MM/YYYY hh:mm")}}</td>
                            <td class="single-line" style="display: flex; align-items: center">
                                <v-icon :color="props.item.read_status ? '#B2B4C6' : '#F7722F'" size="10px" class="mr-1">
                                    mdi-checkbox-blank-circle
                                </v-icon>
                                {{ $t(props.item.read_status ? 'didRead' : 'unread') }}
                            </td>
                            <td class="single-line">
                                <v-btn icon small @click="toggleReadStatus(props.item)">
                                    <v-icon v-if="props.item.read_status">mdi-eye-off-outline</v-icon>
                                    <v-icon v-else>mdi-eye</v-icon>
                                </v-btn>
                                <v-btn icon small @click="chatNow(props.item)">
                                    <v-icon>mdi-chat</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import TimeRangePicker from "@/modules/fptai/components/TimeRangePicker";
import UserService from "src/services/user.service";

export default {
    name: "Notification",
    components: { TimeRangePicker },
    data () {
        return {
            items: [],
            search: '',
            status: 'all',
            typeFilter: 'all',
            timeRange: 'today',
            totalItems: 0,
            pagination: {
                page: 1,
                rowsPerPage: 10
            }
        }
    },
    computed: {
        statusList () {
            return [
                { text: this.$filters.capitalize(this.$t('unread')), value: false },
                { text: this.$filters.capitalize(this.$t('didRead')), value: true },
                { text: this.$filters.capitalize(this.$t('all')), value: null },
            ]
        },
        typeList () {
            return [
                { text: this.$filters.capitalize(this.$t('notifyRequestSupport')), value: "user_request_support" },
                { text: this.$filters.capitalize(this.$t('notifyAssignedSupport')), value: "admin_assign_support" },
                { text: this.$filters.capitalize(this.$t('warning')), value: "warning" },
                { text: this.$filters.capitalize(this.$t('all')), value: null },
            ]
        },
        headers () {
            return [
                { text: this.$filters.capitalize(this.$t('title')), value: 'formatted_msg', sortable: false },
                { text: this.$filters.capitalize(this.$t('startTime')), value: 'created_time', sortable: false },
                { text: this.$filters.capitalize(this.$t('status')), value: 'status', sortable: false },
                { text: this.$filters.capitalize(this.$t('action')), value: 'action', sortable: false },
            ]
        },
    },
    mounted () {
        this.refresh()
    },
    methods: {
        refresh () {
            let {from, to} = this.$refs.TimeRangePicker.getTimestamp();
            let type_filter = this.typeFilter === 'all' ? null : this.typeFilter;
            UserService.getUserNotifies({
                read_status: this.status,
                text_filter: this.search,
                type_filter,
                created_time_from: new Date(from).toISOString(),
                created_time_to: new Date(to).toISOString()
            }, this.pagination.page, this.pagination.rowsPerPage).then(response => {
                let data = [];
                for (let notify of response.data.results) {
                    if (!!notify && !!notify.content && !!notify.extra_data) {
                        let {formatted_msg, message} = UserService.format_notify_message(notify)
                        notify.formatted_msg = formatted_msg;
                        notify.content = message;
                    }
                    data.push(notify);
                }

                this.items = data;
                this.totalItems = response.data.count
            })
        },
        toggleReadStatus(notify) {
            notify.read_status = !notify.read_status;
            UserService.updateUserNotifyReadStatus([notify._id], notify.read_status);
        },
        chatNow (notify) {
            notify.read_status = true;
            UserService.callMarkAllAsRead([notify]);
            let bot_code = notify.extra_data.bot_code,
                sender_id = notify.extra_data.sender_id;
            this.$router.push(`/bot/${bot_code}/s/${sender_id}`);
        },
        format_notify_message: UserService.format_notify_message,
        go_back() {
            let chatView = this.$store.state.chatView,
                bot = this.$store.state.bot;
            if (chatView && chatView.botCode && chatView.senderId) {
                this.$router.push(`/bot/${chatView.botCode}/s/${chatView.senderId}`)
            } else if(bot && bot.code) {
                this.$router.push(`/bot/${bot.code}`);
            } else {
                this.$router.push("/")
            }
        }
    },
    watch: {
        status: 'refresh',
        typeFilter: 'refresh',
        timeRange: 'refresh',
        pagination: {
            deep: true,
            handler: function () {
                this.refresh()
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";

    .page-header {
        background: #0052CC;
        height: $headerHeight;
    }

    .page-title {
        color: #fff;
        font-size: 18px;
    }

    .page-body {
        padding: 20px;
    }

    ::v-deep .single-line {
        white-space: nowrap;
    }
</style>
